<template>
  <div class="header-container">
    <div class="back" @click="back">
      <Icon name="arrow-left" />
    </div>
    <Search
      class="van-hairline--surround"
      v-model="value"
      placeholder="请输入搜索关键词"
      @search="onSearch"
    />
  </div>
</template>

<script>
import { Search, Icon } from 'vant'
export default {
  components: {
    Search,
    Icon,
  },
  data() {
    return {
      value: null,
    }
  },
  methods: {
    onSearch() {
      this.$emit('search')
    },
    back() {
      this.$router.back()
    },
  },
}
</script>

<style lang="less" scoped>
.header-container {
  display: flex;
  justify-content: space-between;
  padding: 8px 20px;
  background-color: #c82d26;
  .back {
    color: #fff;
    display: grid;
    place-items: center;
    font-size: 30px;
  }
  .van-search {
    flex: 1;
    padding: 0;
    margin-left: 30px;
    background-color: #c82d26;
    &::after {
      display: none;
      border-color: #c82d26;
      border-radius: 72px;
    }
    & /deep/ .van-cell {
      display: flex;
      align-items: center;
    }
    & /deep/ .van-search__content {
      background-color: #fff;
      border-radius: 72px;
      .van-field__left-icon {
        color: #e82035;
        font-size: 32px;
      }
      .van-field__control {
        font-size: 28px;
        line-height: 1em;
      }
    }
  }
}
</style>